import { Show, type JSX } from 'solid-js';
import { useActiveBot } from '../state/activeBot';
import Text from './Text';
import GroupScopeBar from './GroupScopeBar';

interface BotScopedProps {
    children: JSX.Element;
    groupAware?: boolean;
}

export default function BotScoped(props: BotScopedProps) {
    const { bot } = useActiveBot();

    return (
        <>
            <GroupScopeBar groupAware={props.groupAware ?? false} pageAligned />
            <Show
                when={bot()}
                fallback={
                    <div style={{
                        padding: 'var(--spacing-2xl)',
                        "max-width": '32rem',
                        margin: '0 auto',
                        "text-align": 'center',
                        color: 'var(--dark-text-muted)',
                    }}>
                        <i class="fa-solid fa-robot" style={{ "font-size": '3rem', opacity: 0.5, "margin-bottom": 'var(--spacing-lg)' }} />
                        <p><Text val="BOT_SCOPED_EMPTY" /></p>
                    </div>
                }
            >
                {props.children}
            </Show>
        </>
    );
}
